import { LocalStorage } from "quasar"

export default function () {
  return {
    currentItem: false,
    items: [],
    itemsCountById: {},
    loading: false,
    ready: false,
    scheduledAt: LocalStorage.has('scheduledAt') ? LocalStorage.getItem('scheduledAt') : false,
    special_request: LocalStorage.has('special_request') ? LocalStorage.getItem('special_request') : '',
    price: LocalStorage.has('cart.price') ? LocalStorage.getItem('cart.price') : 0
    // mealOrders: []
    // enabledExtras: []
  }
}
